import type { IPopup } from "@mm-frontend/mm-web-ui-kit";
import { SignInPhoneStepForm } from "./SignInPhoneStepForm";

export class SignInPhoneStepController {
  public popup: IPopup;
  public form: SignInPhoneStepForm;

  constructor({ popup }: { popup: IPopup }) {
    this.popup = popup;
    this.form = new SignInPhoneStepForm();
  }
}